export default __webpack_public_path__ + "static/media/vector-pagi-3.65e36e5e.svg";